import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { getServiceNameWithNickname } from "../../../utils/getServiceNameWithNickname";
import Notification from "../../elements/notification/Notification";
import GoToBackButton from "../../elements/goToBack/GoToBack";
import { useHistory } from "react-router-dom";
import RenderStatus from "../../styles/styledStatus";
import { TextField } from "@material-ui/core";
import ProcessingBalanceRefilingForm from "../../payments/superAdmin/ProcessingBalanceRefilingForm";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import PageSpinner from "../../elements/spinner/PageSpinner";
import ClipboardInput from "../../elements/copyToClipboard/ClipboardInput";
import * as moment from "moment";
import { AppContext } from "../../../App";

import { StyledBlockLabel, StyledFormBlock, StyledFormGrid, StyledInputBlock } from "../../styles/styledTabsForm";
import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledPayoutDetailsWrapper } from "../styledPayout";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";

const PayoutDetailsContainer = ({ match }) => {
  const history = useHistory();
  let [payout, setPayout] = useState();

  const { user } = useContext(AppContext);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  // add pusher
  const updateTransaction = (message) => {
    payout = JSON.parse(message.data);
    setPayout(payout);
  }

  const fetchPayout = () => {
    axios.get("/api/payouts/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setPayout(response.data);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchPayout();
  }, []);

  if (!payout) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>Детали выплаты • eXsoft.io</title>
        </Helmet>
        <StyledPayoutDetailsWrapper>
          <div className="refiling-details-head">
            <GoToBackButton
              pb="10"
              handler={() => {history.goBack();}}
            />
            <div className="refiling-details-head__status">
              <RenderStatus status={payout.status.value} />
            </div>
          </div>
          <StyledFormGrid>
            <StyledFormBlock>
              <StyledBlockLabel>
                Заявка на выплату
              </StyledBlockLabel>
              <StyledInputBlock>
                <ClipboardInput
                  label="Id"
                  value={payout.id}
                  readonly={true}
                />
                <ClipboardInput
                  label="Reference id"
                  value={payout.referenceId}
                  readonly={true}
                />
                <TextField
                  className="grid-form__input"
                  label="Проект"
                  type="text"
                  value={payout.connection.project.name}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label="Сервис"
                  type="text"
                  value={getServiceNameWithNickname(payout.connection.service.name, payout.connection.service.nickname)}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label="Платежная система"
                  type="text"
                  value={payout.paymentSystem.name}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label="Валюта"
                  type="text"
                  value={payout.currency.asset}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label="Заявленная сумма"
                  type="text"
                  value={payout.amount}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label="Выплаченная сумма"
                  type="text"
                  value={payout.processedAmount}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label="Дата создания"
                  type="text"
                  value={moment((payout.createdAt * 1000)).format("DD-MM-YYYY, H:mm:ss")}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label="Дата обновления"
                  type="text"
                  value={moment((payout.updatedAt * 1000)).format("DD-MM-YYYY, H:mm:ss")}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label="Тип платежа"
                  type="text"
                  value={payout.paymentType}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label="Тип транзакции"
                  type="text"
                  value={payout.transactionType}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                {payout.relatedReferenceId &&
                  <TextField
                    className="grid-form__input"
                    label="Related reference id"
                    type="text"
                    value={payout.relatedReferenceId}
                    variant="filled"
                    InputProps={{
                      readOnly: true
                    }}
                  />
                }
                {payout.note &&
                  <TextField
                    className="grid-form__input"
                    label="Примечание"
                    type="text"
                    value={payout.note}
                    variant="filled"
                    InputProps={{
                      readOnly: true
                    }}
                  />
                }
              </StyledInputBlock>
              <div className="clear-column" />
            </StyledFormBlock>
            {payout.status.value === "NEW" &&
              <ProcessingBalanceRefilingForm
                payment={payout}
                notification={notification}
                setNotification={setNotification}
                type="payouts"
                fetchAction={fetchPayout}
              />}
          </StyledFormGrid>
        </StyledPayoutDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default PayoutDetailsContainer;